import { useContext } from 'react';
import { LanguageContext } from '../components/LanguageContext';

const useLanguage = () => useContext(LanguageContext);

export { useLanguage };
